import { render, staticRenderFns } from "./MailAdd.vue?vue&type=template&id=4ce6b84e&scoped=true"
import script from "./MailAdd.vue?vue&type=script&lang=js"
export * from "./MailAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce6b84e",
  null
  
)

export default component.exports